module.exports = __webpack_public_path__ + "img/phone.3973b426.svg";